<template>
  <v-footer
    fixed
    color="blue lighten-4"
  >
    <v-container
      pa-0
      class="d-flex justify-center align-center"
    >
      <v-container pa-0 mr-4>
        <v-text-field
          :label="$t('List.input')"
          v-model="name"
        ></v-text-field>
      </v-container>
      <v-btn
        depressed
        color="primary"
        @click="createSheet()"
      >{{ $t('List.createButton') }}</v-btn>
    </v-container>
    <v-container
      pa-0
    >
      <div class="adsense">
        <slot></slot>
      </div>
    </v-container>
  </v-footer>
</template>

<script>
import common from '@/mixins/common'
import db from '@/mixins/db'
import jsonSheet from '@/json/sheet.json'

export default {
  mixins: [common, db],
  props: ['sheets'],
  data () {
    return {
      name: ''
    }
  },
  methods: {
    // -------- DB利用 --------
    createSheet () {
      const sheet = JSON.parse(JSON.stringify(jsonSheet))
      sheet.ver = this.ver
      sheet.time = this.getTime()
      if (this.name) {
        sheet.name = this.name
      } else {
        sheet.name = '(Non Title)'
      }

      this.openDb(() => {
        const store = this.startTransaction('readwrite')
        const req = store.put(sheet)
        req.onsuccess = (e) => {
          this.name = ''
          this.$emit('set-sheets')
        }
        req.onerror = (e) => {
          alert('[createSheet openDb Error] Sorry, application error.')
          return false
        }
      })
    }
    // -------- /DB利用 --------
  }
}
</script>
